import type { MRT_ColumnDef } from "mantine-react-table-open";
import {
  MantineReactTable,
  useMantineReactTable
} from "mantine-react-table-open";
import { useMemo } from "react";
import { LoadOrError } from "../../../components/LoadOrError/LoadOrError";
import { getDefaultMRTOptions } from "../../../mantine/getDefaultMRTOptions";
import { emptyArray } from "../../../utils/constants";
import type {
  ExpressOnboardingGenerator,
  ExpressOnboardingVollmachtenSite
} from "../ExpressOnboarding.types";
import useExpressOnboardingGenerators from "../ExpressOnboardingGeneratorsTable/hooks/useExpressOnboardingGenerators";
import { getExpressOnboardingVollmachtenTableVollmachtenColumn } from "./columns/getExpressOnboardingVollmachtenTableVollmachtenColumn";

function ExpressOnboardingVollmachtenTable() {
  // todo: Implement new BE-Endpoint including optiguide status for each Site https://node-energy.atlassian.net/browse/EX-24
  const {
    data: generators,
    isLoading,
    error
  } = useExpressOnboardingGenerators(null);

  const sites = useMemo(
    () => (generators ? getUniqueSites(generators) : emptyArray),
    [generators]
  );

  const defaultOptions = getDefaultMRTOptions<ExpressOnboardingVollmachtenSite>(
    {
      emptyRowsFallbackText: "Es gibt noch keine Liegenschaften",
      searchTextInput: {
        placeholder: "Suche nach Liegenschaft"
      },
      initialState: {
        showGlobalFilter: true
      },
      hideBorder: true
    }
  );

  const columns: Array<MRT_ColumnDef<ExpressOnboardingVollmachtenSite>> = [
    {
      id: "site_name",
      header: "Liegenschaft",
      accessorKey: "site_name"
    },
    {
      ...getExpressOnboardingVollmachtenTableVollmachtenColumn()
    }
  ];

  const table = useMantineReactTable<ExpressOnboardingVollmachtenSite>({
    ...defaultOptions,
    columns: columns,
    data: sites
  });

  return (
    <LoadOrError error={error} loading={isLoading}>
      <MantineReactTable table={table} />
    </LoadOrError>
  );
}

function getUniqueSites(
  generators: Array<ExpressOnboardingGenerator>
): Array<ExpressOnboardingVollmachtenSite> {
  const sitesById = new Map(
    generators.map((generator) => [
      generator.site_id,
      { site_id: generator.site_id, site_name: generator.site_name }
    ])
  );
  return [...sitesById.values()];
}

export { ExpressOnboardingVollmachtenTable };
